<template lang="">
    <v-row>
      <v-col cols="12">
        <v-card 
        class="mx-auto"
    >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-form
        class="m-5"
    ref="form"
    
    lazy-validation
  >
     
    <v-row>

        <v-col cols="6"> 
            <v-autocomplete
                label="Sucursal"
                :items="sucursal"
                v-model="form_s"
                >
            </v-autocomplete>

        </v-col>

        <v-col cols="6"> 
            <v-text-field
            label="Numero de Control"
            outlined
            disabled
            v-model="numeroC"
          ></v-text-field>

        </v-col>

        <v-col cols="6"> 
            <v-autocomplete
                label="Placa / Serial"
                :items="asignacionI"
                v-model="vp">
            </v-autocomplete>
        </v-col>
        
        <v-col cols="6"> 
            <v-autocomplete
                label="Equipo"
                :items="asignacionVM"
                v-model="vm">
            </v-autocomplete>

        </v-col>

          <v-col cols="6" v-if="!swithChage"> 
              <v-autocomplete
                  label="Nombre del conductor"
                  :items="vehiculo_notiene_asignacion?asignacionCNfull:asignacionCN"
                  v-model="cn">
              </v-autocomplete>
          </v-col>

          <v-col cols="6" v-if="!swithChage"> 
              <v-autocomplete
                  label="Cédula"
                  :items="vehiculo_notiene_asignacion?asignacionDNIfull:asignacionDNI"
                  v-model="ci">
              </v-autocomplete>
          </v-col>

          <v-col class="d-flex" cols="6" v-if="swithChage"> 
              <v-text-field
                  label="Nombre del Conductor Sustituto"
                  disabled
                  v-model="cn">
              </v-text-field>
              <v-btn @click.prevent="editar()" class="mx-2" fab dark small color="primary">
                  <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
          </v-col>

          <v-col cols="6" v-if="swithChage"> 
              <v-text-field
                  label="Identificacion del conductor"
                  disabled
                  v-model="ci">
              </v-text-field>
          </v-col>
         
        
          <v-col cols="6"> 
            <v-text-field
                label="Hora Inicio"
                type="time"
                v-model="H_I"
                >
            </v-text-field>
        </v-col>
        
        <v-col cols="6"> 
            <v-text-field
                label="Hora Finalización"
                type="time"
                v-model="H_F"
                >
            </v-text-field>
        </v-col>

        <v-col cols="6"> 
            <v-text-field
                label="Kilometraje Inicio"
                type="number"
                v-model="K_I"
                
                >
            </v-text-field>
        </v-col>
        
        <v-col cols="6"> 
            <v-text-field
                label="Kilometraje de Finalización"
                type="number"
                v-model="K_F"
                >
            </v-text-field>
        </v-col>

        <v-col cols="12"> 
            <v-text-field
                label="Trayectoria"
                v-model="Trayectoria"
                >
            </v-text-field>
        </v-col>


          <v-col cols="12"> 
            <v-text-field
            label="S.T"
            placeholder="S.T"
            outlined
            v-model="form_st"
          ></v-text-field>
        </v-col>

        <v-col cols="12"> 
            <v-text-field
            label="Ord"
            placeholder="Ord"
            outlined
            v-model="form_ord"
          ></v-text-field>
        </v-col>

        <v-col cols="12"> 
            <v-text-field
            label="Viaje"
            placeholder="Viaje"
            outlined
            v-model="form_v"
          ></v-text-field>
        </v-col>

        <v-col cols="12"> 
            <v-text-field
            label="Bono Nocturno"
            placeholder="Bono Nocturno"
            outlined
            v-model="form_bn"
          ></v-text-field>
        </v-col>

        <v-col cols="12" class="d-flex align-content-end">
            <v-textarea
              outlined
              name="input-7-4"
              label="Agregar un comentario (opcional)"
              v-model="alerta">
            </v-textarea>
        </v-col>

    </v-row>
    
  

    

    <v-btn
      
      color="primary"
      class="mr-4"
      @click="Guardar" 
      :loading="status"
      :disabled="!form_st!=''||!form_v!=''||!form_ord!=''||!form_bn!=''|| !cn !='' || !ci !='' || !vm !='' || !vp!='' || !form_s !=''"
    >
      GUARDAR REGISTRO
    </v-btn>

    
  </v-form>
        </v-col>
      </v-row>
    </v-container>
        
    </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
    class="mx-auto"
    max-width="300"
    tile
  >
   
  </v-card>
          
      </v-col>
      
      <div class="text-center">
   <v-overlay light opacity="0.48" z-index="9999" :value="overlay">
      <v-card
      light
    class="mx-auto"
    min-width="600"
  >
  <v-btn
        icon
        @click="cerrarOverlay"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
            
            

    <v-card-subtitle class="pb-0">Cambio de conductor</v-card-subtitle>

    <v-card-text class="text--primary">
      <v-col cols="12" class="d-flex align-content-end">
                  <v-autocomplete
                      label="Conductor"
                      :items="asignacionCNfull"
                      v-model="cn_change_borrador">
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" class="d-flex align-content-end">
                       <v-textarea
                          outlined
                          name="input-7-4"
                          label="Motivos del cambio del conductor"
                          v-model="alerta_change_borrador">
                        ></v-textarea>
                </v-col>


                  <v-col cols="12">
     <v-btn
        @click="guardarChange"
        :disabled="!cn_change_borrador!=''||!alerta_change_borrador!=''"
        color="primary"
      >
        Guardar
      </v-btn>

      <v-btn
        color="orange"
        text
        @click="cerrarOverlay"
        
      >
        Cerrar
      </v-btn>
                </v-col>

    </v-card-text>

    <v-card-actions>
      
    </v-card-actions>
  </v-card>
    </v-overlay>
    </div>
    </v-row>
</template>
<script>

import {SubirLista} from '../../../../../../services/register/lista'


export default {

    mounted() {
        
        this.numeroControl(5, 999999999);
        
     
       

    },

    data: () => ({
     
     numeroC:'',
    status:false,
     conductor:[],
     vehiculo:[],
     dni:[],
     placa:[],
     overlay: false,
     validatechange:false,

    alerta:'',
    form_s:'',
    form_vm:'',
    form_vp:'',
    form_cn:'',
    form_ci:'',
    form_v:'',
    form_st:'',
    form_ord:'',
    form_bn:'',
    K_I:'',
    K_F:'',
    H_I:'',
    H_F:'',
    Trayectoria:'',

    cn_change_borrador:'',
    alerta_change_borrador:'',

    cn_change:'',
    alerta_change:'',

    }),


    computed: {
    
        sucursal(){
            return this.$store.state.sucursal;
        },

          vehiculo_notiene_asignacion(){
            return this.$store.state.vehiculo_notiene_asignacion
          },

         asignacion2(){
            //this.form_vm = this.$store.state.selected_create_register.asignacion;
            return this.$store.state.selected_create_register;
         },

         asignacionCN(){
            return this.$store.getters.asignacionConductor;
         },

         asignacionCNfull(){
            return this.$store.getters.asignacionConductorfull;
         },

         asignacionVM(){
             return this.$store.getters.asignacionVehiculofull;
         },

         asignacionDNI(){
           return this.$store.getters.asignacionDNI;
         },

          asignacionDNIfull(){
            return this.$store.getters.asignacionDNIfull;
          },

         asignacionI(){
          return this.$store.getters.asignacionIdentificacionfull;
         },

        vp:{
           get(){
             return this.$store.getters.vp;
           },
           set(newName){
             this.form_vp = newName;
             return this.$store.dispatch('filterRegisterCreate', {'type':'vp', 'item':newName})
           }
           
         },

         vm:{
          get(){
             return this.$store.getters.vm;
           },
           set(newName){
             this.form_vm = newName;
             return this.$store.dispatch('filterRegisterCreate', {'type':'vm', 'item':newName})
           }
        },


         cn: {
           get(){
             return this.$store.getters.cn;
           },
           set(newName){
             this.form_cn = newName;
             if (newName == 'Otro conductor') {
               this.overlay = true;  
             }
             return this.$store.dispatch('filterRegisterCreate', {'type':'cn', 'item':newName})
           } 
         },

         ci:{
           get(){
             return this.$store.getters.ci;
           },
           set(newName){
             this.form_ci = newName;
             return this.$store.dispatch('filterRegisterCreate', {'type':'ci', 'item':newName})
           }
         },
         
         
         conductor(){
           return this.$store.state.conductor
         },

         swithChage:{

           get(){
             return this.$store.state.changeConductorSwith;
           },
            set(newName){
              return this.$store.dispatch('action_switch_change_driving', newName)
              // console.log(newName);
           }

         }


    },

    methods: {

      editar:function(){
        this.swithChage = false;
      },
      
      guardarChange:function(){

            
           this.cn_change = this.cn_change_borrador;
           this.alerta_change = this.alerta_change_borrador;
           this.$store.dispatch('filterRegisterCreateChange',this.cn_change)
           this.$toastr.success('Se ha cambiado el conductor')
           this.cerrarOverlay();
        
        },

      cerrarOverlay(){

            this.cn_change_borrador = '';
            this.alerta_change_borrador = '';
            this.overlay = false;
      },

     numeroControl:function(min, max) {
        this.numeroC = Math.ceil(Math.random() * (max - min) + min);
     },

      complementoform1:function(){

        for (let e = 0; e < this.asignacion.length; e++) {
          
          this.conductor.push(this.asignacion[e].conductor);
          this.vehiculo.push(this.asignacion[e].asignacion);
          this.dni.push(this.asignacion[e].dni);
          this.placa.push(this.asignacion[e].matricula);
          
        }
      },

      vaciarcampos:function(){

        this.form_cn = ''
          this.form_ci = ''
          this.form_vm= ''
          this.form_vp= ''
        this.form_v= ''
          this.form_bn= ''
          this.form_st= ''
          this.form_ord= ''
        this.form_s= ''

      },
     
     Guardar:function(){

       this.status = true
        this.$store.dispatch('LoadingFetchActions', true);

       var data = new FormData;
       data.append('cn', this.cn);
       data.append('ci', this.ci);
       data.append('vm', this.vm);
       data.append('vp', this.vp);
       data.append('v', this.form_v);
       data.append('bn', this.form_bn);
       data.append('st', this.form_st);
       data.append('ord', this.form_ord);
       data.append('s', this.form_s);
       data.append('alerta_change', this.alerta_change);
       data.append('cn_change', this.cn_change);
       data.append('alerta', this.alerta);
       data.append('k_i', this.K_I);
       data.append('k_f', this.K_F);
       data.append('h_i', this.H_I);
       data.append('h_f', this.H_F);
       data.append('trayectoria', this.Trayectoria);

       SubirLista(data).then(response=>{

          this.$router.push({path: '/registro'});
          this.$store.dispatch('GetListas');
          this.$toastr.success('Se ha agregado una nueva registro');
          this.status = false;
          this.editar();
          this.vaciarcampos();
          this.$store.dispatch('filterRegisterDelete');
          this.$store.dispatch('LoadingFetchActions', false);

       }).catch(errors=>{
         console.log(errors);
         this.$toastr.error(errors);
        this.status = false;
        this.$store.dispatch('LoadingFetchActions', false);
       });

     }
    
    
    
    },




}
</script>